import { ComparisonPlan, Pricing } from '../types'
import Plan from './Plan'
import type PlanVariant from './PlanVariant'
import { initCoreVariants } from './core'
import { initNormalVariants } from './normal'

export type CustomPlanDTO = {
  corePlans: Plan[]
  normalPlans: Plan[]
  comparisonPlans: ComparisonPlan[]
}

function getPlans(rawBundles: Pricing, country: string) {
  const normalVariants = initNormalVariants(rawBundles, country)
  const { coreVariants } = initCoreVariants(rawBundles, country)

  return {
    corePlans: groupVariants(coreVariants),
    normalPlans: groupVariants(normalVariants),
    comparisonPlans: rawBundles.comparisonPlans,
  }
}

function groupVariants(variants: PlanVariant[]): Plan[] {
  const plans: Record<PlanVariant['title'], Plan> = {}

  variants.forEach((variant) => {
    const plan = plans[variant.title]
    if (!plan) {
      plans[variant.title] = new Plan(variant)
    } else {
      plan.addVariant(variant)
    }
  })
  return Object.values(plans)
}

export default getPlans
